import Main from './Main'
import { LayoutMain, MainWrapper } from './Main.styled'

export default Main

export { LayoutMain, MainWrapper }
